var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_SUPPLIERS) && _vm.supplier)?_c('div',[_c('router-link',{attrs:{"to":{ name: 'View Supplier', params: { id: _vm.supplier.id } }}},[_vm._v(" "+_vm._s(`${_vm.supplier.company_name}`)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }